import { useCallback, useMemo } from "react";
import { useQuery } from "urql";
import { DepartmentListQry } from "api/queries/user";
import { useAuthStore } from "stores/authStore";
import { useAppBaseContext } from "../providers/AppBaseProvider";

export const useUserDepartments = () => {
  const { isSameProj } = useAppBaseContext();
  const setUserDepartment = useAuthStore.use.actions().setDepartment;
  const selectedDepartment = useAuthStore.use.department();

  const [{ data: departmentsData, error, fetching, stale }] = useQuery({
    query: DepartmentListQry,
    variables: {
      input: {
        onlyMyDepartments: true,
        page: 1,
        size: 1000,
      },
    },
    requestPolicy: "cache-first",
    pause: !isSameProj,
  });

  const isLoading = fetching || stale;

  const departmentsOptions = useMemo(() => {
    if (departmentsData?.departments?.items && !isLoading) {
      const {
        departments: { items: departments },
      } = departmentsData;
      const options = departments.map((dept) => ({
        value: dept.id,
        label: dept.name,
      }));
      let matchExists = false;
      selectedDepartment?.value &&
        options.forEach((opt) => {
          if (opt.value === selectedDepartment.value) {
            matchExists = true;
          }
        });
      if ((!selectedDepartment || !matchExists) && options.length > 0) {
        setUserDepartment(options[0]);
      }
      if (options.length === 0) {
        setUserDepartment(null);
      }
      return options;
    }
    return null;
  }, [selectedDepartment, departmentsData, isLoading, setUserDepartment]);

  const handleSelect = useCallback(
    (option) => {
      setUserDepartment(option);
    },
    [setUserDepartment],
  );

  return {
    options: departmentsOptions || [],
    selected: selectedDepartment || null,
    setSelected: handleSelect,
    error: error || null,
  };
};
